import { EAlertCondition, EAlertFrequency } from '@aqx-core/common/api/price-alert';

export enum EPriceAlertTab {
  CURRENT_SYMBOL = 'CURRENT_SYMBOL',
  ALL_SYMBOLS = 'ALL_SYMBOLS'
}

export const MAX_ALERTS_PER_SYMBOL: number = 10;
export const MAX_ALERTS_FOR_ALL_SYMBOLS: number = 50;

export const MINIMUM_PERCENTAGE_VALUE = 0.01;
export const MAXIMUM_PERCENTAGE_VALUE = 100;
export const MINIMUM_PRICE_VALUE = 0;
export const MAXIMUM_PRICE_VALUE = 999999999.99;

export const DEFAULT_POINTS_STEP = 0.0001;
export const DEFAULT_SYMBOL_DECIMALS = 2;

// // Price Alert Item Dimensions
export const PRICE_ALERT_CONTENT_HEIGHT = 60;
export const BOTTOM_BORDER_HEIGHT = 1;

// // Condition Opts
export const CONDITION_OPTS = [EAlertCondition.ABOVE, EAlertCondition.BELOW];

// // Frequency Opts
export const FREQUENCY_OPTS = [EAlertFrequency.ONLY_ONCE, EAlertFrequency.PER_DAY, EAlertFrequency.ALWAYS];

// // Price Alert - Error Message Modal Content // //
export enum EPriceAlertModalMsg {
  DUPLICATED_PRICE_ALERT = 'DUPLICATED_PRICE_ALERT',
  PRICE_ALERT_LIMIT_REACHED = 'PRICE_ALERT_LIMIT_REACHED',
  SYMBOL_TEMPORARILY_DISABLED = 'SYMBOL_TEMPORARILY_DISABLED'
}

// // Price Alert Field Key
export enum EPriceAlertFieldKeys {
  CONDITION = 'CONDITION',
  FREQUENCY = 'FREQUENCY',
  TARGET_VALUE = 'TARGET_VALUE',
  TARGET_VALUE_PERCENT = 'TARGET_VALUE_PERCENT'
}
